import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import messages from '../../messages';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
export function ApiFailedScreenWithLogic({
  endExperience,
  send,
  errorInfo
}) {
  useAnalyticsFlowEventsQueue({
    stepName: 'apiError',
    attributes: {
      errorType: messages.apiError.defaultMessage,
      ...errorInfo
    }
  });
  const isConvoAIServerError = ['FEATURE_DISABLED', 'FEATURE_DISABLED_ON_SITE', 'NO_AGENT'].includes((errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorKey) || '');
  const is5xxErrorRange = typeof (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) === 'number' && errorInfo.statusCode >= 500 && errorInfo.statusCode < 600;
  const isRetryEnabled =
  // 500 status codes should not be retryable
  !is5xxErrorRange &&
  // 9001 is a special case for elevate where we disable generate until
  // Q3
  (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) !== 9001;
  const {
    formatMessage
  } = useIntl();
  const documentationUrl = 'https://status.atlassian.com/';
  const errorMsg = is5xxErrorRange || isConvoAIServerError ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.internalServerError, {
    values: {
      link: message => /*#__PURE__*/React.createElement("a", {
        href: documentationUrl,
        target: "_blank",
        rel: "noopener noreferrer"
      }, message)
    }
  })) : (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) === 9001 ? formatMessage(messages.elevateDisabledGenetateError) : formatMessage(messages.apiError);
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: errorMsg,
    showRetryButton: isRetryEnabled,
    onRetry: function () {
      send({
        type: 'api retry'
      });
    },
    onCancel: function () {
      endExperience();
    }
  });
}